
export enum EQueueType {
	None,
	Enter,
	Damask,
	Return
};

export type EQueueConfigType = {
	contactId: string;
	login: string;
	password: string;
	officeId: number;
	pultId: string;
	pultName: string | null;
	queueServerAddress: string | null;
	autoCallEnabled?: boolean;
	callByTicketNumberEnabled?: boolean;
	callAnotherEnabled?: boolean;
	scheduleEnabled?: boolean;
	transferEnabled?: boolean;
};

export enum WidgetType {
	None,
	Waiting, 
	Calling, 
	Working, 
	OnPause,
	Unknown
};

export type BeginPauseParamsType = {
	reason: string;
	idQ?: string;
};

export type eQueueStatuses = "Offline" | "Idle" | "Waiting" | "Calling" | "Working" | "OnPause";
